<!--
/**
* @name: Add.vue
* @description: 添加广告页面
* @author: 杨波
* @create: 2020/08/17 14:40:37
* @update: 2020/08/17 14:40:37
*/
-->

<template>
  <y-view :title="isEdit ? '编辑广告' : '新增广告'" :loading="isLoading">
    <y-form titleAlign="right" titleWidth="100px" contentWidth="500px">
      <y-form-item title="广告名称:" required>
        <k-input placeholder="请输入，不超过10个字" v-validate="'required|minLength(2)|maxLength(10)'" block maxlength="10" clearable v-model="editPara.advertName"></k-input>
      </y-form-item>
      <y-form-item title="缩略图:" align="top" required>
        <div class="row">
          <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploaded"></y-upload-file>
          <y-image @delete="onDelete1" v-dragging="{ list: imgList, item: img, group: 'image' }" v-for="(img, index) in imgList" :key="index" :index="index" :src="img"></y-image>
        </div>
        <div class="row">注意：小程序端，建议尺寸300*300px，只能上传一张，不超过3M。</div>
        <div class="row mt-2">
          <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedApp"></y-upload-file>
          <y-image @delete="onDelete2" v-dragging="{ list: appImgList, item: img, group: 'image' }" v-for="(img, index) in appImgList" :key="index" :index="index" :src="img"></y-image>
        </div>
        <div class="row">注意：app端，建议尺寸400*300px，只能上传一张，不超过3M。</div>
      </y-form-item>
      <y-form-item title="广告宣传图:" align="top">
        <div class="row">
          <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedPropagandaImg"></y-upload-file>
          <y-image @delete="onDelete3" v-dragging="{ list: propagandaImgList, item: img, group: 'image' }" v-for="(img, index) in propagandaImgList" :key="index" :index="index" :src="img"></y-image>
        </div>
        <div class="row">注意：建议宽度1125px，只能上传一张，用于广告详情页展示在顶部。</div>
      </y-form-item>
      <y-form-item title="跳转类型:" required>
        <div>
          <k-radio @change="changeType" v-model="editPara.jumpType" value="GOODS">商品</k-radio>
          <k-radio @change="changeType" v-model="editPara.jumpType" value="CATEGORY">分类</k-radio>
          <k-radio @change="changeType" v-model="editPara.jumpType" value="BRAND">品牌</k-radio>
          <k-radio @change="changeType" v-model="editPara.jumpType" value="LINK">链接</k-radio>
          <k-radio @change="changeType" v-model="editPara.jumpType" value="TMP_ACTIVITY">活动</k-radio>
        </div>
      </y-form-item>
      <y-form-item v-if="editPara.jumpType == 'GOODS'" title="商品货号:" required>
        <div :class="css.flex">
          <k-input placeholder="请输入商品货号" clearable block v-model="editPara.jumpResource" style="width: 500px;"></k-input>
          <a @click="addGoodsSns">添加</a>
        </div>
      </y-form-item>
      <k-table has-index max-height="300px" :data="goodsSnsList" :rightFixedNumber="1" :class="css.tableW" :columns="goodsSnsColumns()" v-if="this.goodsSnsList.length > 0 && editPara.jumpType == 'GOODS'"></k-table>
      <y-form-item v-if="editPara.jumpType == 'BRAND'" title="选择品牌:" required>
        <k-auto-complete
          style="width: 500px;"
          ref="au"
          :data="brandList"
          v-model="editPara.jumpResource"
          key-field="brandCode"
          value-field="gbname"
          search-field="gbname"
          layer-width=""
          placeholder="请选择商品品牌"
          @focus="onFocus"
          @toggle="onToggle"
          @input="onInput"
          :empty="empty"
          :text="text"
        >
          <div slot-scope="{ row }" :key="row.brandCode" class="list">
            <span class="name">{{ row.gbname }}</span>
          </div>
        </k-auto-complete>
      </y-form-item>
      <y-form-item v-if="editPara.jumpType == 'CATEGORY'" title="选择分类:" required>
        <k-select2
          :data="goodsTypeList"
          text-field="parentNameUrl"
          search-field="parentNameUrl"
          key-field="id"
          style="width: 500px;"
          layer-width="auto"
          layerMinWidthEqual
          :nearby="true"
          placeholder="请选择商品分类"
          v-model="editPara.jumpResource"
        >
        </k-select2>
      </y-form-item>
      <y-form-item v-if="editPara.jumpType == 'LINK'" title="输入链接:" required>
        <k-input placeholder="请输入链接" clearable block v-model="editPara.jumpResource"></k-input>
      </y-form-item>
      <y-form-item v-if="editPara.jumpType == 'TMP_ACTIVITY'" title="输入活动ID:" required>
        <k-input placeholder="请输入活动ID" clearable block v-model="editPara.jumpResource"></k-input>
      </y-form-item>
      <y-form-item v-if="editPara.jumpType == 'TMP_ACTIVITY'" title="活动位:" align="top">
        <div class="row">
          <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedAdvertCampaignImg"></y-upload-file>
          <y-image @delete="onDelete4" v-dragging="{ list: advertCampaignImgList, item: img, group: 'image' }" v-for="(img, index) in advertCampaignImgList" :key="index" :index="index" :src="img"></y-image>
        </div>
        <div class="row">建议尺寸516*300px，只能上传一张，不超过3M。</div>
      </y-form-item>
      <y-form-item title="广告排序:" required>
        <k-input placeholder="请输入" block v-model="editPara.ordinary"></k-input>
      </y-form-item>
      <y-form-item title="生效时间:" required>
        <DatePicker :editable="false" type="datetimerange" @on-change="changeDate" :value="effectDate" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择" style="width: 500px;"></DatePicker>
      </y-form-item>
      <y-form-item title="备注:" align="top">
        <k-input tag="textarea" v-model="editPara.remark" block placeholder="请输入..."></k-input>
      </y-form-item>
    </y-form>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_MARKETING_BACK_SERVER_ADVERT_DETAIL,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_SAVE,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_UPDATE,
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
  NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODSCODESALE,
} from "@/assets/modules/apiList";

const initEditPara = () => ({
  advertName: "",
  advertPositionId: "",
  appThumbImg: "",
  miniAppThumbImg: "",
  ordinary: 0,
  startTime: "",
  remark: "",
  endTime: "",
  jumpType: "",
  jumpResource: "",
});
export default {
  data() {
    return {
      isLoading: false,
      editPara: initEditPara(),
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      isSaving: false,
      isEdit: false,
      originData: {},
      imgList: [],
      appImgList: [],
      propagandaImgList: [],
      brandList: [], //品牌列表
      goodsTypeList: [],
      show: false,
      text: "",
      empty: "",
      positionId: "",
      effectDate: "",
      goodsSnsList: [],
      advertCampaignImgList: []
    };
  },
  computed: {
    startTime() {
      return this.effectDate[0];
    },
    endTime() {
      return this.effectDate[1];
    },
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!this.isView) {
        let advertName = para.advertName.toString().replace(/\s*/g, "");
        para.appThumbImg = this.imgList.join(",");
        para.miniAppThumbImg = this.appImgList.join(",");
        para.startTime = this.effectDate[0];
        para.endTime = this.effectDate[1];
        if (
          advertName.length < 2 ||
          advertName.length > 20 ||
          (!para.appThumbImg && !para.miniAppThumbImg) ||
          (!para.ordinary && para.ordinary != "0") ||
          !para.startTime ||
          !para.endTime ||
          !para.jumpType ||
          (para.jumpType != "GOODS" && !para.jumpResource) ||
          (para.jumpType == "GOODS" && this.goodsSnsList.length === 0)
        ) {
          status = true;
        }
      }
      return status;
    },
  },
  watch: {
    "editPara.jumpType": {
      handler(newName, oldName) {
        if (newName == "CATEGORY") {
          this.getGoodsTypeList();
        } else if (newName == "BRAND") {
          this.getBrandList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    onDeleteGoods(row) {
      this.$dialog({
        title: "提示",
        content: "确认删除当前商品吗？",
        ok: () => {
          for (let index = 0; index < this.goodsSnsList.length; index++) {
            if (this.goodsSnsList[index].id == row.id) {
              this.goodsSnsList.splice(index, 1);
              break;
            }
          }
        },
      });
    },
    addGoodsSns() {
      let { tip } = this.$root;
      if (!this.editPara.jumpResource) {
        return tip("请输入商品货号");
      }
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODSCODESALE,
        para: { goodsCodeSaleList: this.editPara.jumpResource.split(",") },
      }).then((res) => {
        if (res) {
          let msg = "";
          let Arr = [];
          res.forEach((v) => {
            // 判断该商品是否已被添加过
            if (this.goodsSnsList.map((y) => y.goodsCodeSale).indexOf(v.goodsCodeSale) < 0) {
              if (this.goodsSnsList.length < 50) {
                this.goodsSnsList.push(v);
              } else {
                msg = "最多只能添加50个商品";
              }
            } else {
              Arr.push(v.goodsCodeSale);
              msg = `${Arr}商品已被选择`;
            }
          });
          // 输入多个商品货号 某几个不正确
          if (res.length !== new Set(this.editPara.jumpResource.split(",")).size) {
            const arr = this.editPara.jumpResource.split(",").filter((item) => !res.map((y) => y.goodsCodeSale).includes(item));
            msg = `添加失败！商品货号${arr}在系统不存在`;
          }
          if (msg) return tip(msg);
          this.editPara.jumpResource = "";
        } else {
          // 输入一个商品货号 且货号不存在
          return tip("该商品货号不存在，请输入正确的商品货号");
        }
      });
    },
    goodsSnsColumns() {
      return [
        {
          name: "商品货号",
          field: "goodsCodeSale",
          style: {
            width: 80,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "20px",
          },
        },
        {
          name: "商品名称",
          field: "goodsNameSale",
          style: {
            width: 150,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "操作",
          field: "action",
          style: {
            width: 80,
            textAlign: "center",
            "line-height": "18px",
          },
          customRender: (row) => {
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDeleteGoods(row);
                }}
              >
                删除
              </a>
            );
            return <div>{deleteButton}</div>;
          },
        },
      ];
    },
    onFocus() {},
    onToggle(e) {
      // console.log("toggle", e, this.editPara.goodsCodeSale);
    },
    onInput(text) {},
    onDelete1(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.imgList.splice(obj.index, 1);
        },
      });
    },
    onDelete2(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.appImgList.splice(obj.index, 1);
        },
      });
    },
    onDelete3(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.propagandaImgList.splice(obj.index, 1);
        },
      });
    },
    onDelete4(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.advertCampaignImgList.splice(obj.index, 1);
        },
      });
    },
    onUploaded(data) {
      this.imgList = [];
      this.imgList.push(data.data[0].url);
    },
    onUploadedApp(data) {
      this.appImgList = [];
      this.appImgList.push(data.data[0].url);
    },
    onUploadedPropagandaImg(data) {
      this.propagandaImgList = [];
      this.propagandaImgList.push(data.data[0].url);
    },
    onUploadedAdvertCampaignImg(data) {
      this.advertCampaignImgList = [];
      this.advertCampaignImgList.push(data.data[0].url);
    },
    getAdvertDetail(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_ADVERT_DETAIL,
        para: { id: id },
      })
        .then((res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          this.isLoading = false;
          this.effectDate = [res.startTime, res.endTime];
          this.appImgList.push(res.appThumbImg);
          if (res.propagandaImg) {
            this.propagandaImgList.push(res.propagandaImg);
          }
          if(res.advertCampaignImg){
            this.advertCampaignImgList.push(res.advertCampaignImg);
          }
          if (this.editPara.jumpType == "GOODS") {
            this.$fetch({
              api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST_BY_GOODSCODESALE,
              para: { goodsCodeSaleList: this.editPara.jumpResource.split(",") },
            }).then((i) => {
              this.goodsSnsList = i;
              this.editPara.jumpResource = "";
            });
          }
          this.imgList.push(res.miniAppThumbImg);
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    changeType(e) {
      this.editPara.jumpResource = "";
    },
    getBrandList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
        para: {},
      }).then((res) => {
        this.brandList = res;
      });
    },
    getGoodsTypeList() {
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_TYPE_LIST,
        para: { rank: 3, isEnabled: true },
      }).then((res) => {
        this.goodsTypeList = res;
      });
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "advertiseConfig",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
            id: this.positionId,
            positionName: this.positionName,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      this.$refs.au.inputText = '';
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      para.appThumbImg = this.appImgList.join(",");
      if (this.propagandaImgList.length > 0) {
        para.propagandaImg = this.propagandaImgList.join(",");
      } else {
        para.propagandaImg = "";
      }
      if (para.jumpType == "GOODS") {
        if (this.goodsSnsList.length > 0) {
          if (this.goodsSnsList.length > 50) {
            return tip("该优惠券最多只能应用于50个商品");
          }
          let arr = [];
          this.goodsSnsList.forEach((v) => {
            arr.push(v.goodsCodeSale);
          });
          para.jumpResource = arr.join(",");
        }
      }
      para.miniAppThumbImg = this.imgList.join(",");
      para.advertCampaignImg = this.advertCampaignImgList.join(",");
      para.startTime = this.startTime;
      para.endTime = this.endTime;
      para.advertPositionId = this.positionId;
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_MARKETING_BACK_SERVER_ADVERT_UPDATE : NESTLE_MARKETING_BACK_SERVER_ADVERT_SAVE,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    changeDate(date) {
      this.effectDate = date;
    },
  },
  created() {
    const { id, edit, posId, positionName } = this.$route.query;
    this.positionId = posId;
    this.positionName = positionName;
    if (id) {
      if (edit) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.getAdvertDetail(id);
    } else {
      this.isEdit = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, edit, posId, positionName } = to.query;
    this.editPara = initEditPara();
    this.imgList = [];
    this.appImgList = [];
    this.propagandaImgList = [];
    this.effectDate = "";
    this.positionId = posId;
    this.positionName = positionName;
    if (id) {
      if (edit) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
        this.goodsSnsList = [];
      }
      this.getAdvertDetail(id);
    } else {
      this.isEdit = false;
      this.goodsSnsList = [];
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.flex {
  display: flex;
  width: 550px;
  justify-content: space-between;
  align-items: center;
}
.tableW {
  width: 700px;
  padding-left: 60px;
  margin: 10px 0px 20px;
}
</style>
